import React, { FC } from 'react'
import { Input, InputRef } from 'antd'
import styles from './Search.module.scss'
import classNames from 'classnames'
import { SearchProps } from 'antd/es/input'
import { CloseCircleFilled } from '@ant-design/icons'

const Search: FC<SearchProps & React.RefAttributes<InputRef>> = props => {
  return (
    <Input.Search
      {...props}
      allowClear={props.allowClear ? { clearIcon: <CloseCircleFilled className={styles.clear} /> } : false}
      className={classNames(props.className, styles.search)}
      classNames={{
        input: classNames(props.classNames?.input, styles.input),
      }}
    />
  )
}

export default Search
